import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '@ansys-internal/awc-angular/images';
import { MenuBarComponent } from '@ansys-internal/awc-angular/menus';
import { InputComponent } from '@ansys-internal/awc-angular/forms';
import { ConceptInputComponent as CEVInputComponent } from '../components/widgets/forms/input/concept-input.component';
import { ListComponent } from '@ansys-internal/awc-angular/lists';
import { CardComponent } from '@ansys-internal/awc-angular/panels';
import { IconComponent } from '@ansys-internal/awc-angular/icons';
import { TableComponent } from '@ansys-internal/awc-angular/tables';
import { TreeComponent } from '@ansys-internal/awc-angular/trees';
import { SelectComponent } from '@ansys-internal/awc-angular/forms';
import { TabsComponent } from '@ansys-internal/awc-angular/tabs';
import { ScientificNotationPipe } from './pipes/scientific-notation/scientific-notation.pipe';
import { UnitFromTypePipe } from './pipes/unit-from-type/unit-from-type.pipe';
import { UnitNameTransformPipe } from './pipes/unit-name/unit-name-transform.pipe';
import { CyDataDirective } from './directives/cy-data.directive';

@NgModule({
  declarations: [
    ScientificNotationPipe,
    UnitFromTypePipe,
    UnitNameTransformPipe,
    CyDataDirective,
  ],
  imports: [
    CommonModule,
    LogoComponent,
    InputComponent,
    CEVInputComponent,
    TabsComponent,
    MenuBarComponent,
    ListComponent,
    CardComponent,
    IconComponent,
    TableComponent,
    TreeComponent,
    SelectComponent,
  ],
  exports: [
    LogoComponent,
    InputComponent,
    CEVInputComponent,
    TabsComponent,
    MenuBarComponent,
    ListComponent,
    CardComponent,
    IconComponent,
    TableComponent,
    TreeComponent,
    SelectComponent,
    ScientificNotationPipe,
    UnitFromTypePipe,
    UnitNameTransformPipe,
    CyDataDirective,
  ],
})
export class SharedModule {}
